import { Route, Routes } from "react-router-dom"
import { ProtectedRoute } from "../components/auth/ProtectedRoute"
import LoginScreen from "../screens/auth/LoginScreen"
import EnterpriseScreen from "../screens/enterprise/EnterpriseScreen"
import HomeScreen from "../screens/home/HomeScreen"
import ServicesScreen from "../screens/services/ServicesScreen"
import BatchTrackingScreen from "../screens/tracking/BatchTrackingScreen"
import TrackingDirectScreen from "../screens/tracking/TrackingDirectScreen"
import TrackingScreen from "../screens/tracking/TrackingScreen"
import AggregateScreen from "../screens/workwithus/Aggregate"
import CollaboratorScreen from "../screens/workwithus/Collaborator"

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path="/home" element={<HomeScreen />} />
            <Route path="/rastreamento" element={<TrackingScreen />} />
            <Route
                path="/rastreamento/:numerodanota/:serie/:token?"
                element={<TrackingDirectScreen />}
            />
            <Route path="/login" element={<LoginScreen />} />
            <Route
                path="/rastreamento/lote"
                element={
                    <ProtectedRoute>
                        <BatchTrackingScreen />
                    </ProtectedRoute>
                }
            />
            <Route path="/servicos" element={<ServicesScreen />} />
            <Route path="/aempresa" element={<EnterpriseScreen />} />
            <Route path="/trabalheconosco" element={<EnterpriseScreen />} />
            <Route
                path="/trabalheconosco/colaborador"
                element={<CollaboratorScreen />}
            />
            <Route
                path="/trabalheconosco/agregado"
                element={<AggregateScreen />}
            />
            <Route path="*" element={<HomeScreen />} />
        </Routes>
    )
}

export default AppRoutes
